module.exports = __webpack_public_path__ + "bdd892cdf337fc8975aca7ccab6ea06c.svg";